export class OTA_Voucher {
    public supplierIdentifier: string;
    public identifier: string;
}
